import script from "./MaterialInlineNameCell.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialInlineNameCell.vue?vue&type=script&setup=true&lang=js"

import "./MaterialInlineNameCell.vue?vue&type=style&index=0&id=5d85a783&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d85a783"]])

export default __exports__